import {
  PublishParams,
  ChartFields,
  ChartListParams,
  ChartSongs,
} from "../../view/Modules/Charts/ChartDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { SongListParams } from "../../view/Modules/Songs/SongDataTypes";

export const ChartServices = {
  getCharts: (params: ChartListParams) => {
    return AxiosInstance.get(ContentApiRoutes.CHARTS, { params });
  },
  getChartSongs: (id: number, params: SongListParams) => {
    return AxiosInstance.get(
      ContentApiRoutes.CHART_SONGS.replace(":id", id.toString()),
      { params }
    );
  },
  createChart: (data: ChartFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CHART, data),
  updateChart: (id: number, data: ChartFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_CHART.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  addSongsToChart: (id: number, data: ChartSongs) =>
    AxiosInstance.post(
      ContentApiRoutes.ADD_SONGS_TO_CHART.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteSongsFromChart: (id: number, data: ChartSongs) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_SONGS_FROM_CHART.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishChart: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_CHART.replace(":id", id.toString()),
      data
    ),

  deleteChart: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CHART.replace(":id", id.toString())
    ),
  viewChart: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_CHART.replace(":id", id.toString())
    );
  },

  searchCharts: (chart: string) =>
    AxiosInstance.get(ContentApiRoutes.CHARTS + `?smart_search=${chart}`),

  deleteChartLogo: (id: number) =>
    AxiosInstance.put(
      ContentApiRoutes.DELETE_CHART_LOGO.replace(":id", id.toString())
    ),
};
